import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface PageEventArgs {
  accumulate?: boolean;
  limit?: number;
  page: number;
  params?: object;
}

class PageEvent extends EventData<Pageable> implements PageEventArgs {

  accumulate?: boolean;
  limit?: number;
  page: number;
  params?: object;

  constructor({ accumulate, limit, page, params }: PageEventArgs) {
    super();

    this.accumulate = accumulate;
    this.limit = limit;
    this.page = page;
    this.params = params;
  }
}

class PageEventListener extends EventListener<Pageable, PageEvent, PageEventArgs> {
  constructor() {
    super(PageEvent);
  }
}

export default interface Pageable extends Mountable {

  /** @event */
  onNextPage: PageEventListener;

  /** @event */
  onPrevPage: PageEventListener;

}

export { PageEventListener, PageEvent };
